export const OPTION_LIST_TRANSLATE = {
  OPTION_INPUT_PLACEHOLDER: "回答を入力してください。",
};
